export const TEAM_OPTIONS = [
  { id: 'TEAM_A', name: 'TEAM_A' },
  { id: 'TEAM_B', name: 'TEAM_B' }
]

export const CATEGORY_OPTIONS = [
  { id: 'MATCH', name: 'MATCH' },
  { id: 'TEAM', name: 'TEAM' },
  { id: 'ATHLETE', name: 'ATHLETE' },
]

export const SUBCATEGORY_OPTIONS = [
  { id: 'MATCH_RESULT', name: 'MATCH_RESULT' },
  { id: 'MATCH_RESULT_2_WAY', name: 'MATCH_RESULT_2_WAY' },
  { id: 'SCORE_RESULT', name: 'SCORE_RESULT' },
  { id: 'GET_REBOUND', name: 'GET_REBOUND' },
  { id: 'GET_ASSIST', name: 'GET_ASSIST' },
  { id: 'BLOCK_SHOT', name: 'BLOCK_SHOT' },
  { id: 'DOUBLE_DOUBLE', name: 'DOUBLE_DOUBLE' },
  { id: 'TRIPLE_DOUBLE', name: 'TRIPLE_DOUBLE' },
  { id: 'RESULT', name: 'RESULT' },
  { id: 'WIN', name: 'WIN' },
  { id: 'NATIONAL_RECORD', name: 'NATIONAL_RECORD' },
  { id: 'WORLD_RECORD', name: 'WORLD_RECORD' },
]

export const CONDITION_OPTIONS = [
  { id: 'NONE', name: 'NONE' },
  { id: 'LESS_THAN', name: 'LESS_THAN' },
  { id: 'EQUAL', name: 'EQUAL' },
  { id: 'GREATER_THAN', name: 'GREATER_THAN' },
  { id: 'AT_LEAST', name: 'AT_LEAST' },
  { id: 'NO_SCORE', name: 'NO_SCORE' },
  { id: 'NOT', name: 'NOT' },
]
